import { DatePicker } from 'cdk-radial';
import { DateTime } from 'luxon';
import moment, { Moment } from 'moment';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { RDS_DATE_PICKER_SHOW_ONE_MONTH, EVENT_NAME } from 'common/constants';
import { useAmplitude } from 'components/AmplitudeProvider';
import { errors } from 'pages/VendorsTablePage/messages';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { amplitudeTracker } from 'utils/AmplitudeTracker';
import { formattedDate, getDateFormatByLocale } from 'utils/dateUtils';
import { getDueDate, setDueDate } from '../VendorsTable/slice';

export const VendorsTableHeader = (): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const amplitude = useAmplitude();
  const intl = useIntl();
  const dueDate = useAppSelector(getDueDate);
  const [hasError, setHasError] = useState(false);
  const displayDate = getDateFormatByLocale(intl.locale);
  const momentDueDate = dueDate ? moment(dueDate) : null;

  const dateInputProps = {
    isRequired: false,
    hasError,
    errorMessage: intl.formatMessage(errors.invalidDueDate),
    onError: (errorMessages: string[]) => {
      setHasError(errorMessages.length > 0);
    }
  };

  const handleDateChange = (date: Moment | null) => {
    dispatch(setDueDate(formattedDate(date?.toISOString() as string)));
    amplitudeTracker(amplitude, EVENT_NAME.SelectInvoiceDueDate, {
      'Days In Advance Of Invoice': -(
        Math.ceil(
          DateTime.now().diff(
            DateTime.fromISO(formattedDate(date?.toISOString() as string)),
            'days'
          ).days
        ) - 1
      )
    });
  };

  return (
    <div className="vendors-table-header-container">
      <DatePicker
        allowDaysInPast
        date={momentDueDate}
        dateInputProps={dateInputProps}
        dataTestId="due-on-or-before-date"
        dateFormat={displayDate}
        id="due-on-or-before-date"
        label={
          <FormattedMessage
            description="Label for date picker"
            defaultMessage="Due On or Before"
          />
        }
        name="date-picker"
        numberOfMonths={RDS_DATE_PICKER_SHOW_ONE_MONTH}
        onDateChange={handleDateChange}
      />
    </div>
  );
};
